import DealDetails from './DealDetails';

export default DealDetails;
